import { defineApiInterceptor } from '@kouzoh/merpay-api-client';

export const createErrorInterceptor = () =>
  defineApiInterceptor({
    name: 'error',
    onError({ error }) {
      // TODO: The $sentry module needs to be implemented, so it
      //       is commented out for now.
      // const { status, message } = error;

      // // send only 5xx error to sentry
      // if (this.context.$sentry && status && status >= 500) {
      //   this.context.$sentry.captureEvent({
      //     message,
      //   });
      // }

      throw error;
    },
  });
